/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  fetchFacebookPages({ omniauthToken, channelType }) {
    return axios.post(`${this.url}/facebook_pages`, {
      omniauth_token: omniauthToken,
      channel_type: channelType,
    });
  }

  registerFacebookPage(params) {
    return axios.post(`${this.url}/registration`, params);
  }

  reauthorizeFacebookPage({ omniauthToken, inboxId }) {
    return axios.post(`${this.url}/reauthorization`, {
      omniauth_token: omniauthToken,
      inbox_id: inboxId,
    });
  }
}

export default new InstagramChannel();
